export enum ConsultantReferenceStatus {
  Empty = "Empty",
  NotRequested = "NotRequested",
  Approved = "Approved",
  ApprovedWithException = "ApprovedWithException",
  NotApproved = "NotApproved",
  RequestSentToKVK = "RequestSentToKVK",
  RequestSentToReference = "RequestSentToReference",
  RequestExpired = "RequestExpired",
  AwaitingApproval = "AwaitingApproval",
  RequestNotAnswered = "RequestNotAnswered"
}

export enum ConsultantReferenceType {
  Reference = "Reference",
  Evaluation = "Evaluation",
  EvaluationToThreeMonths = "EvaluationToThreeMonths", // not used anymore
  UUCrossQuestions = "UUCrossQuestions" // former UUNationalCrossQuestions
}

export enum ConsultantReferenceRelation {
  CurrentBoss = "CurrentBoss",
  LatestBoss = "LatestBoss",
  FormerBoss = "FormerBoss",
  CurrentColleague = "CurrentColleague",
  FormerColleague = "FormerColleague"
}

export enum ConsultantReferenceReminderType {
  FourDays = "FourDays",
  SevenDays = "SevenDays",
  EightDays = "EightDays",
  FourteenDays = "FourteenDays",
  SixMonthsWarning = "SixMonthsWarning"
}
